// Наше волшебное число существует по следующим причинам:
// 1. когда мы раскрываем коллапс, мы мереем высоту содержимого, но в случае если она 0,
//    не сработает transition так как высота остается прежней и блок фактически остается свернут
//    данная же высота пинает брауезер все же создать запустить анимацию
// 2. когда мы далее передаем наш транзишен мы также полностью убираем его длительность,
//    но опять же если длительность 0, то проигрываться он не будет,
//    поэтому вновь используем наше волшебное число для длительности.
const MAGIC_NUMBER = 0.0001;

// Подставляет MAGIC_NUMBER когда раскрытая высота 0
export const getExpandedHeight = height => {
  if (height === undefined) {
    return undefined;
  }
  return `${height || MAGIC_NUMBER}px`;
};
// Отдает transition длительностью и задержкой в MAGIC_NUMBER когда высота MAGIC_NUMBER
// То есть проигрывает ее максимально быстро
export const getTransitionStyle = ({
  height,
  overflow,
  duration,
  delay
}) => {
  if (overflow === undefined) return undefined;
  const transitionDuration = height === `${MAGIC_NUMBER}px` ? MAGIC_NUMBER : duration;
  const transitionDelay = delay && height !== `${MAGIC_NUMBER}px` ? delay : 0;
  const result = `height ${transitionDuration}ms ease ${transitionDelay}ms`;
  return result;
};